module.exports = __webpack_public_path__ + "img/jingyan_01.cb496af7.png";